import { url } from '../actions/actionTypes';
export const initialState = {
    filesUrls: {},
    photosUrls: {},
    searchUrl: null,
    vaultNotesUrl: null,
};
export default function (state = initialState, action) {
    switch (action.type) {
        case url.NEXT_FILES_URL:
            const nextFilesUrlPayload = action.payload;
            return { ...state, filesUrls: { ...state.filesUrls, [nextFilesUrlPayload.folderId]: nextFilesUrlPayload.url } };
        case url.NEXT_PHOTOS_URL:
            const nextPhotosUrlPayload = action.payload;
            return {
                ...state,
                photosUrls: { ...state.photosUrls, [nextPhotosUrlPayload.albumId]: nextPhotosUrlPayload.url },
            };
        case url.NEXT_SEARCH_URL:
            const nextSearchUrlPayload = action.payload;
            return { ...state, searchUrl: nextSearchUrlPayload };
        case url.NEXT_VAULT_NOTES_URL:
            const nextVaultNotesUrlPayload = action.payload;
            return { ...state, vaultNotesUrl: nextVaultNotesUrlPayload };
        default:
            return state;
    }
}
